/**
 * Created by Ram on 19/09/2016.
 */

import React, { Component } from "react";

class Dashboard extends Component {
  render() {
    return (
      <div className="container-fluid mainContentBody">
        <div className="mainDiv">
          <nav className="navbar navbar-inverse admin-top-nav navbar-fixed-top top-tmp-nav">
            <div className="container-fluid">
              <ul className="nav navbar-nav row test-portal-top-nav">
                <li className="col-sm-4">
                  <div className="navbar-header">
                    <div className="portalLogo" />
                    <div className="app-header">Test Management Portal</div>
                    <button
                      type="button"
                      className="navbar-toggle"
                      data-toggle="collapse"
                      data-target=".navbar-collapse"
                    >
                      <span className="sr-only">Toggle Navigation</span>
                      <span className="icon-bar" />
                      <span className="icon-bar" />
                      <span className="icon-bar" />
                    </button>
                  </div>
                </li>
                <li className="col-sm-2">
                  <a
                    onClick={this.props.navigator.requestTestInstanceManagement}
                  >
                    <span className="glyphicon glyphicon-asterisk" /> TEST
                    INSTANCES
                  </a>
                </li>
                <li className="col-sm-2">
                  <a onClick={this.props.navigator.requestScenarioManagement}>
                    <span className="glyphicon glyphicon-picture" /> SCENARIOS
                  </a>
                </li>
                <li className="col-sm-2">
                  <a onClick={this.props.navigator.requestDeviceManagement}>
                    <span className="glyphicon glyphicon-phone" /> DEVICES
                  </a>
                </li>
                <li className="col-sm-2">
                  <a onClick={this.props.navigator.requestAnalyticsPagination}>
                    <span className="glyphicon glyphicon-stats" /> ANALYTICS
                  </a>
                </li>
              </ul>
            </div>
          </nav>

          <div className="centralContent">{this.props.activeView}</div>
        </div>
      </div>
    ); //return
  } //render
} //Dashboard

export default Dashboard;
